import { render, staticRenderFns } from "./UserNotificationDialog.vue?vue&type=template&id=1308f41c&"
import script from "./UserNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./UserNotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports